<template>
  <v-alert
    v-if="hasStalePrinter"
    type="warning"
    dense
    tile
    class="ma-0 sdp-health-banner"
  >
    {{ bannerMessage }}
  </v-alert>
</template>

<script>
import { onMounted, onUnmounted } from '@vue/composition-api'
import useSdpPrinterHealth from '@/views/composable/useSdpPrinterHealth'

// SDPプリンタのポーリング途絶をレイアウト共通で知らせる警告バナー。
// 表示条件・文言は useSdpPrinterHealth 側に集約(SDP無効店舗では何も出ない)
export default {
  name: 'SdpPrinterHealthBanner',
  setup() {
    const {
      hasStalePrinter, bannerMessage, startWatching, stopWatching,
    } = useSdpPrinterHealth()

    onMounted(startWatching)
    onUnmounted(stopWatching)

    return {
      hasStalePrinter,
      bannerMessage,
    }
  },
}
</script>

<style scoped>
.sdp-health-banner {
  font-size: 0.875rem;
}
</style>
